export const games = {
  RIOT: "라이엇 계정",
  LOL: "리그 오브 레전드",
  LOR: "레전드 오브 룬테라",
  TFT: "전략적 팀 전투",
  VALORANT: "VALORANT"
};
